import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/(base)/event/[eventId]/EventPageClient.tsx");
